
import { useNavigate } from 'react-router-dom';

interface ToolsTabProps {
  onClose: () => void;
}

export const ToolsTab: React.FC<ToolsTabProps> = ({ onClose }) => {
  const navigate = useNavigate();

  const tools = [
    {
      label: 'MFE Sandbox',
      description: 'Component isolation',
      icon: 'fa-cubes',
      route: '/sandbox?developer=1',
      color: 'pink',
    },
    {
      label: 'Redux Slices',
      description: 'State inspector',
      icon: 'fa-atom',
      route: '/redux?developer=1',
      color: 'purple',
    },

  ];

  const handleNavigate = (route: string) => {
    navigate(route);
    onClose();
  };

  return (
    <div className="flex flex-col gap-4">
      <h4 className="text-xs font-extrabold uppercase tracking-wider text-text-muted flex items-center gap-2">
        <i className="fa-solid fa-toolbox text-primary-accent"></i> Developer Tools & Views
      </h4>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {tools.map((tool) => (
          <button
            key={tool.route}
            onClick={() => handleNavigate(tool.route)}
            className={`p-4 rounded-2xl bg-bg-surface border border-border-color hover:border-${tool.color}-500/50 hover:bg-${tool.color}-500/5 flex items-center gap-3 transition-all duration-300 text-left cursor-pointer group`}
          >
            <span className={`inline-flex items-center justify-center w-9 h-9 rounded-xl bg-${tool.color}-500/10 text-${tool.color}-400 border border-${tool.color}-500/20 group-hover:scale-105 transition-transform`}>
              <i className={`fa-solid ${tool.icon} text-base`}></i>
            </span>
            <div className="min-w-0">
              <span className={`block text-xs font-bold text-text-primary group-hover:text-${tool.color}-400 transition-colors`}>
                {tool.label}
              </span>
              <span className="block text-[10px] text-text-muted truncate">{tool.description}</span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ToolsTab;
